<!-- 自动化思维识别表单 -->
<template>
  <div>
    <div class="chat-card">
      <div class="card flex">
        <img class="calendar-icon" src="@/assets/images/calendar_2.png" alt="月份选择" />
        <ChatInput style="flex: 1" label="日期/时间:" v-model="formData.time" />
      </div>
      <div class="card">
        <AssociateInput label="*情境" v-model="formData.scene" :paragraph="sceneArr" />
      </div>
      <div class="card">
        <AssociateInput
          label="*自动化思维"
          v-model="formData.autoThought"
          :paragraph="automatedThinkingArr"
        />
      </div>
      <div class="card">
        <AssociateInput
          label="*情绪与生理反应"
          v-model="formData.response"
          :paragraph="emotionArr"
        />
      </div>
      <div class="card">
        <AssociateInput
          label="*行为和/或结果"
          v-model="formData.result"
          :paragraph="resultArr"
        />
      </div>
      <div class="required">*必填项目。</div>
      <button v-if="isCanEdit" class="confirm-btn" @click="confirmFn">确定</button>
    </div>
    <!-- <div v-if="cardData.isShowTime" class="send-time">09月01日 16:29</div> -->
  </div>
</template>

<script>
import ChatInput from "../ChatInput/index.vue";
import AssociateInput from "@/components/AIChatting/AssociateInput/index.vue";

export default {
  name: "ChatText",
  props: {
    cardData: {
      type: Object,
      default() {
        return {
          isShowTime: true,
        };
      },
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  components: {
    ChatInput,
    AssociateInput,
  },
  data() {
    //console.log("cardData", JSON.stringify(this.cardData));
    return {
      formData: {
        time: "",
        scene: "",
        autoThought: "",
        response: "",
        result: "",
      },
      sceneArr: [
        {
          text: "发生什么事件、",
        },
        {
          text: "出现什么想法、",
        },
        {
          text: "白日梦或回忆之后你感到不愉快、",
        },
        {
          text: "伤心或有其他烦恼?",
        },
        {
          text: "你处在什么环境下感到不愉快、伤心或有其他烦恼?",
        },
        {
          text: "你察觉身体上有什么不舒服后出现不愉快、",
        },
        {
          text: "伤心或有其他烦恼?",
        },
      ],
      automatedThinkingArr: [
        {
          text: "那个时候你脑子里想到了什么?",
        },
        {
          text: "那个时候你马上想到了什么?",
        },
        {
          text: "那个时候你脑子里出现的第一个想法是什么?",
        },
        {
          text: "那个时候你的第一反应是什么?",
        },
        {
          text: "那个时候你的直觉是什么?",
        },
        {
          text: "那个时候你脑子里浮现了(出现了或跳出了)什么画面?",
        },
        {
          text: "那个时候有什么画面在你脑海里跳出来或闪现出来?",
        },
        {
          text: "想到了什么让你有这样的情绪？",
        },
        {
          text: "出现情绪时你脑子里想到了什么？",
        },
        {
          text: "出现这样身体不舒服的感觉时，你想到了什么？",
        },
      ],
      emotionArr: [
        {
          text:
            "当时你有什么情绪反应(悲伤/焦虑/愤怒等)？每个情绪反应的强烈程度是多少(0~10分)?",
        },
        {
          text: "你的身体感受到了什么？每种感受的强烈程度是多少(0~10分)?",
        },
      ],
      resultArr: [
        {
          text: "你当时做了什么来应对这种情形？",
        },
        {
          text: "这样做了后又发生了什么？事情有什么变化？",
        },
        {
          text: "后来发生了什么？",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 提交数据
    confirmFn() {
      if (
        !(
          this.formData.scene &&
          this.formData.autoThought &&
          this.formData.response &&
          this.formData.result
        )
      ) {
        return this.$toast("请输入必填项");
      }
      let useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: this.cardData.step_type,
                answer: this.formData,
              },
            ],
          },
        },
      };
      this.$emit("confirmFn", useData);
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 100%;
  .card {
    width: 100%;
    background: rgba(232, 227, 252, 1);
    padding: 15px;
    box-sizing: border-box;
    border-radius: 10px;
    margin-bottom: 10px;
  }
  .flex {
    display: flex;
    align-items: center;
    img {
      width: 13px;
      height: 14px;
      margin-right: 6px;
    }
  }
  .required {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0px;
    color: rgba(121, 72, 234, 0.62);
  }
}
.confirm-btn {
  width: 76px;
  height: 25px;
  border-radius: 12px;
  background: #ad7eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.23px;
  color: #fff;
  border: none;
  margin: 10px auto 0;
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}
</style>
